import { APP_BASE_HREF } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/input',
    pathMatch: 'full',
  },
  {
    path: 'avatar',
    loadChildren: () =>
      import('@modules/avatar/avatar.module').then((m) => m.AvatarModule),
  },
  {
    path: 'button',
    loadChildren: () =>
      import('@modules/button/button.module').then((m) => m.ButtonModule),
  },

  {
    path: 'card',
    loadChildren: () =>
      import('@modules/card/card.module').then((m) => m.CardModule),
  },
  {
    path: 'card-overlay',
    loadChildren: () =>
      import('@modules/card-overlay/card-overlay.module').then(
        (m) => m.CardOverlayModule
      ),
  },
  {
    path: 'checkbox',
    loadChildren: () =>
      import('@modules/checkbox/checkbox.module').then((m) => m.CheckboxModule),
  },
  {
    path: 'chip',
    loadChildren: () =>
      import('@modules/chip/chip.module').then((m) => m.ChipModule),
  },
  {
    path: 'datepicker',
    loadChildren: () =>
      import('@modules/datepicker/datepicker.module').then(
        (m) => m.DatepickerModule
      ),
  },
  {
    path: 'dropdown-button',
    loadChildren: () =>
      import('@modules/dropdown-button/dropdown-button.module').then(
        (m) => m.DropdownButtonModule
      ),
  },
  {
    path: 'expansion-panel',
    loadChildren: () =>
      import('@modules/expansion-panel/expansion-panel.module').then(
        (m) => m.ExpansionPanelModule
      ),
  },
  {
    path: 'footer',
    loadChildren: () =>
      import('./modules/footer/footer.module').then((m) => m.FooterModule),
  },
  {
    path: 'header',
    loadChildren: () =>
      import('@modules/header/header.module').then((m) => m.HeaderModule),
  },
  {
    path: 'icon',
    loadChildren: () =>
      import('@modules/icon/icon.module').then((m) => m.IconModule),
  },
  {
    path: 'input',
    loadChildren: () =>
      import('@modules/input/input.module').then((m) => m.InputModule),
  },
  {
    path: 'menu',
    loadChildren: () =>
      import('./modules/menu/menu.module').then((m) => m.MenuModule),
  },
  {
    path: 'modal',
    loadChildren: () =>
      import('@modules/modal/modal.module').then((m) => m.ModalModule),
  },
  {
    path: 'navbar',
    loadChildren: () =>
      import('./modules/navbar/navbar.module').then((m) => m.NavbarModule),
  },
  {
    path: 'pagination',
    loadChildren: () =>
      import('@modules/pagination/pagination.module').then(
        (m) => m.PaginationModule
      ),
  },
  {
    path: 'password-level',
    loadChildren: () =>
      import('./modules/password-level/password-level.module').then(
        (m) => m.PasswordLevelModule
      ),
  },
  {
    path: 'password-security',
    loadChildren: () =>
      import('./modules/password-security/password-security.module').then(
        (m) => m.PasswordSecurityModule
      ),
  },
  {
    path: 'radio-button',
    loadChildren: () =>
      import('@modules/radio-button/radio-button.module').then(
        (m) => m.RadioButtonModule
      ),
  },
  {
    path: 'required-message',
    loadChildren: () =>
      import('@modules/required-message/required-message.module').then(
        (m) => m.RequiredMessageModule
      ),
  },
  {
    path: 'select',
    loadChildren: () =>
      import('@modules/select/select.module').then((m) => m.SelectModule),
  },
  {
    path: 'sidenav',
    loadChildren: () =>
      import('@modules/sidenav/sidenav.module').then((m) => m.SidenavModule),
  },
  {
    path: 'tab',
    loadChildren: () =>
      import('@modules/tab/tab.module').then((m) => m.TabModule),
  },
  {
    path: 'text',
    loadChildren: () =>
      import('./modules/text/text.module').then((m) => m.TextModule),
  },
  {
    path: 'textarea',
    loadChildren: () =>
      import('@modules/textarea/textarea.module').then((m) => m.TextareaModule),
  },
  {
    path: 'typography',
    loadChildren: () =>
      import('@modules/typography/typography.module').then(
        (m) => m.TypographyModule
      ),
  },
  {
    path: 'breadcrumb',
    loadChildren: () =>
      import('@modules/breadcrumb/breadcrumb.module').then(
        (m) => m.BreadcrumbModule
      ),
  },
  {
    path: 'switch',
    loadChildren: () =>
      import('@modules/switch/switch.module').then((m) => m.SwitchModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [{ provide: APP_BASE_HREF, useValue: '/' }],
})
export class AppRoutingModule {}
